import React from 'react'
import { useQuery } from '@tanstack/react-query'
import type { KambiSportsSelection } from '@mobi/betslip/types'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { queryClient } from '@core/Data/ReactQuery'
import { createKambiBetRequest } from '@core/Areas/Quickbet/helpers/betting/kambiSports/utils/createBetRequest'
import { postValidateKambiSportsBet } from '@core/Data/Betting/kambiSports'

export const useGetKambiRewardsForSelection = (selection: KambiSportsSelection) => {
  const { data, isError } = useQuery({
    queryKey: queryKeys.kambiPlayerRewards,
    queryFn: () =>
      postValidateKambiSportsBet(createKambiBetRequest({ selection, investmentWin: 1 })),
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  })

  React.useEffect(() => {
    // Clear data on unmount
    return () => queryClient.removeQueries({ queryKey: queryKeys.kambiPlayerRewards })
  }, [])

  if (isError || !data) return null

  return data.rewardInfo
}
